const calculatePanoramaHeight = () => {
  let height = '420px';
  const width = window.innerWidth;
  if (width > 575) {
    height = '470px';
  }
  if (width > 767) {
    height = '500px';
  }
  if (width > 991) {
    height = '535px';
  }

  return height;
};

export default calculatePanoramaHeight;
